import type { SxProps } from '@mui/material';
import { Typography } from 'hephaestus/web';
import { householdColors, memberColors } from './memberColors';

export type MemberTagArgs = {
  sequenceNumber: number | 'HOUSEHOLD';
  name: string;
};

export const MemberTag = ({ sequenceNumber, name }: MemberTagArgs) => {
  const colors =
    sequenceNumber === 'HOUSEHOLD'
      ? householdColors
      : memberColors(sequenceNumber);

  return (
    <Typography
      variant='bodySmall'
      align='center'
      color={colors.fg}
      sx={[
        {
          fontSize: 11,
          fontWeight: 600,
          bgcolor: colors.bg,
        },
        ...(Array.isArray(tagSx) ? tagSx : [tagSx]),
      ]}
    >
      {name}
    </Typography>
  );
};

const tagSx: SxProps = {
  display: 'inline-block',
  paddingLeft: '5px',
  paddingRight: '5px',
  borderRadius: '2px',
  height: '16.5px',
};
